module.exports = __webpack_public_path__ + "img/9 Control Icons.778d2f9f.svg";